import Head from 'next/head';
import React from 'react';
import { Query } from 'react-apollo';
import Fade from 'react-reveal/Fade';
import { ParallaxProvider } from 'react-scroll-parallax';
import styled from 'styled-components';
import getPressKit from '../../src/apollo/graphql/press/getPressKit';
import Breadcrumb from '../../src/components/Breadcrumb';
import { Column, Container } from '../../src/components/Grid';
import Header from '../../src/components/Header';
import { Main, Media, Page, Push, Section } from '../../src/components/Layout';
import Watermark from '../../src/components/Parallax/Watermark';
import Wysiwyg from '../../src/components/Wysiwyg';
import { withI18N } from '../../src/hoc/index';
import { media } from '../../src/styles/media';
import Release from './Release';
import createContext from '../../src/utils/format/createContext';

const StyledColumn = styled(Column)`
  margin-bottom: ${props => props.theme.layout.gutter * 3}px;
`;

const DropFilterWrapper = styled.div`
  display: none;

  position: absolute;
  top: 0;
  right: ${props => props.theme.layout.gutter * 0.75}px;

  ${media.tablet`
    display: block;
  `};
`;

const MediaWrapper = styled.div`
  margin: ${props => props.theme.layout.gutter * 2.75}px
    ${props => props.theme.layout.gutter * -0.75}px 0;

  .image-fit--root {
    padding: 0 15px;
  }

  ${media.tablet`
    .image-fit--root {
      padding: 0;
    }
  `} ${media.desktop`
    margin: ${props => props.theme.layout.gutter * 5}px ${props =>
    props.theme.layout.gutter * 1.25}px ${props =>
    props.theme.layout.gutter * 3.5}px;
  `};
`;

class Press extends React.PureComponent {
  renderPage = page => {
    const { t } = this.props;
    return (
      <div>
        <Head>
          <title key="title">Grand Hôtel-Dieu</title>
        </Head>
        <Header
          title={page.detail.title}
          image={page.img_header_desktop}
          imageMobile={page.img_header_mobile}
        />
        <Main>
          <Container>
            <Breadcrumb
              items={[
                { href: '/', label: t('common:nav.tabs.home') },
                { label: page.detail.title }
              ]}
            />
          </Container>
          <Section>
            <Container>
              <Fade up>
                <MediaWrapper>
                  <Media
                    img={page.img_visual_desktop}
                    link={page.detail.cta_url}
                    linkLabel={page.detail.cta_label}
                    directLink
                    textEditor
                    radial={true}
                  >
                    <Wysiwyg bigTitle content={page.detail.content} />
                  </Media>
                </MediaWrapper>
              </Fade>
            </Container>
          </Section>
          <Section noMarginBottom>
            <Fade up>
              <Push
                label={page.detail.push_cta_label}
                link={page.detail.push_cta_url}
                background={page.img_push_desktop}
                backgroundMobile={page.img_push_mobile}
              />
            </Fade>
          </Section>
          <Release />
        </Main>
      </div>
    );
  };
  render() {
    const { i18n } = this.props;

    return (
      <Page press>
        <Query query={getPressKit} context={createContext(i18n.language)}>
          {({ loading, error, data }) => {
            if (!loading && !error && data && data.getPressKit) {
              if (!error && data.getPressKit) {
                return this.renderPage(data.getPressKit);
              }
              return null;
            }

            return null;
          }}
        </Query>
      </Page>
    );
  }
}

export default withI18N()(Press);
